import { IFilter } from '../models/Filter'
import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export const list = async ({ offset, filter, order }: IFilter) => {
  return httpRequest.post(`/ord/pull_sheet/list`, { filter, offset, order })
}

export const get = async (id: string) => {
  return httpRequest.get(`/ord/pull_sheet/${id}`)
}

export const create = async (data: { warehouseId: string; loadingDate: any; deliveryNoteIds: any; warehouseStaffId?: string | null }) => {
  return httpRequest.post(`/ord/pull_sheet`, data)
}

export const warehouseStaffSelect = async (data: any) => {
  return httpRequest.get("/ord/pull_sheet/warehouse_staff_select", data)
}

/** `regenerate` skips the cached file (contract §2: GET /pull_sheet/:id/pdf?regenerate=1). */
export const pdf = async (id: string, regenerate = false): Promise<{ url: string }> => {
  return httpRequest.get(`/ord/pull_sheet/${id}/pdf`, regenerate ? { regenerate: 1 } : undefined)
}

export const shortageCount = async (): Promise<{ count: number }> => {
  return httpRequest.get(`/ord/pull_sheet/shortages/count`)
}

/** Warehouse keeper accepts a load the loading clerk finished (CONFIRMED -> LOADED). Creates the warehouse -> driver handovers. */
export const confirm = async (id: string) => {
  return httpRequest.put(`/ord/pull_sheet/${id}/confirm`)
}
